import React from "react";
import Modal from "./Modal";
// import { setNotification } from "../../helpers/notification";
import moment from "moment";

import TitleValue from "../TitleValue/TitleValue";
import Button from "../Button";
import { useTranslation } from "react-i18next";

export default function OrganizationRegistrationModal(props) {
  const { t } = useTranslation();

  const {
    organizationId,
    transactionDate,
    approve,
    PassiveDate,
    loading,
    isOpen,
    toggle,
  } = props;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <>
        <div className="km__p--certificate-edit-header">
          {t("pages.default.offersAndMatches.modal.statusTitle")}
        </div>
        <div className="km__p--certificate-edit-body">
          <TitleValue
            title={t("pages.default.offersAndMatches.organizationId")}
            value={organizationId}
            size="lg"
          />
          <TitleValue
            title={t("pages.default.offersAndMatches.transactionDate")}
            value={moment(transactionDate).format("DD.MM.YYYY HH:mm:ss")}
            size="lg"
          />
          <TitleValue
            value={` Bu organizasyon ${PassiveDate} yılı içerisinde pasif hale getirilmiştir. Yeniden Aktif yapmak istiyor musunuz?`}
            size="lg"
          />
        </div>
        <div className="km__p--certificate-edit-footer">
          <Button
            label={t("pages.default.offersAndMatches.close")}
            type="secondary"
            onClick={toggle}
          />
          <Button
            type="primary"
            onClick={approve}
            label={t("ui.default.approve")}
            id="confirmation-approve"
            disabled={loading}
          />
        </div>

        {/* {!marketMatchId && (
          <div className="km__c--modal-certificate-loading">
            <Loading />
          </div>
        )} */}
      </>
    </Modal>
  );
}
